export default class TranscriptSearch {
    searchText: string

    // Determines which speaker channel to highlight
    speakerChannel: speakerChannels

    // Determines logic for which words are highlighted
    mode: eSearchModes

    // Similar words to those provided in the search text
    similarWords: string[] = []

    setSpeakerToAgent = () => {
        this.speakerChannel = speakerChannels.Agent;
    };

    setSpeakerToCustomer = () => {
        this.speakerChannel = speakerChannels.Customer;
    };

    setSearchMode = (val: eSearchModes) => {
        this.mode = val;
    };

    setSimilarWords = (similarWords: string[]) => {
        this.similarWords = similarWords;
    }
}

enum speakerChannels {
    Agent = 'Agent',
    Customer = 'Customer'
}

export enum eSearchModes {
    Any = 'Any',
    All = 'All',
    Similar = 'Similar',
    Phrase = 'Phrase'
}